import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { CALLOUT_BACKGROUND } from 'lib/form-field-styles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: CALLOUT_BACKGROUND,
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(0.5),
  },
  body: {
    whiteSpace: 'pre-line',
    overflowWrap: 'anywhere',
  },
}))

const CancellationPolicy = ({ policy }) => {
  const classes = useStyles()
  if (!policy?.trim()) return null

  return (
    <Box className={classes.root} data-testid="cancellation-policy">
      <Typography variant="body1" className={classes.title}>
        Cancellation policy
      </Typography>
      <Typography variant="body2" className={classes.body}>
        {policy}
      </Typography>
    </Box>
  )
}

CancellationPolicy.propTypes = {
  policy: PropTypes.string,
}

export default CancellationPolicy
